import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X } from "lucide-react";

const CATS = ["All", "Products", "Events", "Projects"];

export default function Gallery() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("All");
    const [lightbox, setLightbox] = useState(null);

    useEffect(() => {
        api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
    }, []);

    const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

    return (
        <div data-testid="gallery-page">
            <section className="bg-ink text-white py-24 md:py-28">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                    <div className="overline text-primary mb-4">Gallery</div>
                    <h1 className="font-display text-5xl md:text-7xl font-bold leading-[1] tracking-tight">
                        Moments & milestones.
                    </h1>
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-12">
                <div className="flex flex-wrap gap-2 mb-8">
                    {CATS.map((c) => (
                        <button
                            key={c}
                            onClick={() => setFilter(c)}
                            className={`px-4 py-2 text-sm font-semibold border transition-colors ${
                                filter === c ? "bg-primary text-white border-primary" : "border-border hover:border-primary"
                            }`}
                            data-testid={`gallery-filter-${c.toLowerCase()}`}
                        >
                            {c}
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {filtered.map((g) => (
                        <button
                            key={g.id}
                            onClick={() => setLightbox(g)}
                            className="group aspect-square overflow-hidden bg-surface relative"
                            data-testid={`gallery-item-${g.id}`}
                        >
                            <img src={g.media_url} alt={g.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                            <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/40 transition-colors flex items-end p-3 opacity-0 group-hover:opacity-100">
                                <div className="text-white text-xs font-semibold">{g.title}</div>
                            </div>
                        </button>
                    ))}
                </div>
            </section>

            {lightbox && (
                <div className="fixed inset-0 bg-ink/95 z-50 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-testid="gallery-lightbox">
                    <button onClick={() => setLightbox(null)} className="absolute top-5 right-5 text-white p-2">
                        <X className="w-6 h-6" />
                    </button>
                    <img src={lightbox.media_url} alt={lightbox.title} className="max-w-full max-h-[85vh] object-contain" />
                    <div className="absolute bottom-6 left-0 right-0 text-center text-white font-display">{lightbox.title}</div>
                </div>
            )}
        </div>
    );
}
